import api from './api';

// Payment Method API endpoints
const PAYMENT_METHOD_BASE_URL = '/admin/wallet/payment-methods/';

export const getPaymentMethods = async (params = {}) => {
  try {
    const response = await api.get(PAYMENT_METHOD_BASE_URL, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch payment methods');
  }
};

export const getPaymentMethod = async (id) => {
  try {
    const response = await api.get(`${PAYMENT_METHOD_BASE_URL}${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch payment method');
  }
};

export const createPaymentMethod = async (paymentMethodData) => {
  try {
    const response = await api.post(PAYMENT_METHOD_BASE_URL, paymentMethodData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create payment method');
  }
};

export const updatePaymentMethod = async (id, paymentMethodData) => {
  try {
    const response = await api.put(`${PAYMENT_METHOD_BASE_URL}${id}/`, paymentMethodData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update payment method');
  }
};

export const deletePaymentMethod = async (id) => {
  try {
    const response = await api.delete(`${PAYMENT_METHOD_BASE_URL}${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to delete payment method');
  }
};

